export const pluginKeyName = 'sparams';
export const settingOwner = 'postmaster@portal.blip.ai';
export class SortMenuOptionsService {
    static $inject = ['ConfigurationsService'];
    constructor(ConfigurationsService) {
        this.ConfigurationsService = ConfigurationsService;
    }
    async isCustomMenuOrder(useConfigurationsApplication = false) {
        const settings = await this.ConfigurationsService.get(settingOwner, undefined, useConfigurationsApplication);
        return settings.CustumizedMenu !== undefined && JSON.parse(settings.CustumizedMenu.toLowerCase()) || false;
    }
    async sortMenuOptions(menuItems, useConfigurationsApplication = false) {
        const settings = await this.ConfigurationsService.get(settingOwner, undefined, useConfigurationsApplication);
        const custumizedMenuOrder = JSON.parse(settings.CustumizedMenuOrder).menuOrder || {};
        menuItems = menuItems.filter((value, index, arr) => {
            return custumizedMenuOrder.includes(value.sref);
        });
        menuItems.sort((a, b) => {
            a = pluginKeyName in a && custumizedMenuOrder.includes(a.sparams.pluginId) ? a.sparams.pluginId : a.sref;
            b = pluginKeyName in b && custumizedMenuOrder.includes(b.sparams.pluginId) ? b.sparams.pluginId : b.sref;
            return custumizedMenuOrder.indexOf(a) - custumizedMenuOrder.indexOf(b);
        });
        return menuItems;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
SortMenuOptionsService.$inject = ['ConfigurationsService'];
